import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'reactstrap';
import { ButtonFilter } from '../ButtonFilter';
import CloseManyButton from '../CloseManyButton';
import TransferManyButton from '../TransferManyButton';
import { Controller, useForm } from 'react-hook-form';
import FlexSelect from 'components/Inputs/FlexSelect';
import { FlexSelectSearchTag } from 'components/Inputs/SelectWithSearch';
import { UserFlexSelect } from 'components/UserFlexSelect';
import TableLoader from 'components/ContentLoaders/contentLoaderTable';
import TableMonitoring from '../table';
import { ChatSituations } from 'utils/fuctions/mapSituationChat';
import { useSocketLoggedAttendants } from '../../hooks/useSocketLoggedAttendants';
import CardAttendants from '../CardAttendants';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { useSelector } from 'react-redux';
import { ImageButton, ImageSize } from 'assets/styles/image_style';
import exelReport from '../../services/apiReportMonitoring';
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import xlsxImage from '../../../../../../assets/img/xlsx.png';
import { Tooltip } from '@material-ui/core';
// // eslint-disable-next-line
// import MonitoringChatWorker from 'works/chat.worker';
import { useConversationConnectionSocketForMonitoring } from 'hooks/useConversationConnectionSocketForMonitoring';
import { useConectionSocketAdmConversation } from 'hooks/useSocketAdmConversations';
import { SearchChatsInput } from 'views/ServicePanel/components/QueueContent/styled';
import { SearchButton } from 'views/ServicePanel/components/QueueContent/styled';
import { IoSearch } from 'react-icons/io5';
import { useWorker } from 'hooks/useWork';
import ConversationReportService from 'views/ChatConfiguration/service';
import { dddsData, stateData } from '../../utils/ListStateAndDdd';
import { ColMonitoring, RowMonitoring } from './styled';
import { buttonsFilterMonitoring, CHAT_SITUATIONS_FILTER } from './utils';
import { useRequestUsers } from 'hooks/useUserContext';
import { useAccounts } from 'hooks/useAccounts';
import { FlexController } from 'components/FlexControllerInput';
import Loader from 'react-loader-spinner';
import DateRangeFilter from 'components/DateRangeFilter/DateRangeFilter';
import { format } from 'date-fns';
import { LOCAL_STORAGE_KEYS } from 'utils/fuctions/localStorage';

export const MonitoringDetails = ({
  queues,
  canalOptions,
  getMonitoringData,
  monitoringData,
  setMonitoringData,
  isLoadingMonitoringData
}) => {
  let idTimeoutSearch = null;
  const { sendMessageWork, addMessageListener } = useWorker(
    'src/works/chat.worker.js'
  );
  const { socketConversation } = useConversationConnectionSocketForMonitoring();
  const { socketAdm } = useConectionSocketAdmConversation();

  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const isFirstRender = React.useRef(true);

  const [usersShowDisable, setUsersShowDisable] = useState(true);
  const [situationFilter, setSituationFilter] = useState(
    CHAT_SITUATIONS_FILTER.ALL
  );
  const [possibleEvents, setPossibleEvents] = useState({});
  const { loggedAttendants } = useSocketLoggedAttendants();
  const { users } = useRequestUsers();

  const [filtersDataDTO, setFiltersDataDTO] = useState({});
  const [selectedRows, setSelectedRows] = useState({});
  const [tagsIdName, setTagsIdName] = useState({});
  const [sorting, setSorting] = useState([]);
  const [orderByFilter, setOrderByFilter] = useState('hora');
  const [
    shouldCreateProtocolOnConversationEnd,
    setShouldCreateProtocolOnConversationEnd
  ] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    register,
    errors,
    clearErrors
  } = useForm();

  const { accountsOptions } = useAccounts({
    recordTypeId: 0,
    sortConfig: { key: 'name', direction: 'ascending' }
  });

  const handleChangeSituationFilter = useCallback(
    async (newSituationFilter) => {
      setSituationFilter(newSituationFilter);
      await handleFilterConversations({
        situation: newSituationFilter
      });
    },
    [handleFilterConversations]
  );

  useEffect(() => {
    if (!sorting || !sorting[0]?.id) return;

    let orderBy;

    if (sorting?.[0] === 'hora_criacao') {
      orderBy = `${sorting.id}${sorting.desc ? '' : 'Asc'}`;
    }

    orderBy = `${sorting.id}${sorting.desc ? 'Desc' : ''}`;
    setOrderByFilter(orderBy);
    handleFilterConversations({
      orderBy
    });
  }, [sorting[0]?.desc, sorting[0]?.id]);

  const handleNewFilters = useCallback(
    async (filters = {}) => {
      const {
        loginAtendente,
        atendente,
        fila,
        nome,
        telefone,
        situacao,
        orderBy,
        canal,
        tags,
        messagem,
        state,
        ddd,
        conta,
        startDate,
        endDate
      } = filters;

      const filtersDTO = {
        loginAtendente,
        atendente,
        fila,
        nomeDoCliente: nome,
        telefoneDoCliente: telefone,
        orderBy,
        canal,
        tags,
        messagem,
        state: state?.flatMap((state) => state) || null,
        ddd,
        isOnHold: false,
        conta,
        startDate,
        endDate
      };

      switch (situacao) {
        case CHAT_SITUATIONS_FILTER.ALL:
          filtersDTO.situacao = undefined;
          break;
        case CHAT_SITUATIONS_FILTER.ANSWERED:
          filtersDTO.situacao = ChatSituations.IN_ATTENDANCE;
          break;
        case CHAT_SITUATIONS_FILTER.UNANSWERED:
          filtersDTO.situacao = 'nao_atendida';
          break;
        case CHAT_SITUATIONS_FILTER.BOT_ATTENDANCE:
          filtersDTO.tipoDeAtendimento = 'atendimento_bot';
          break;
        case CHAT_SITUATIONS_FILTER.HUMAN_ATTENDANCE:
          filtersDTO.tipoDeAtendimento = 'atendimento_humano';
          break;
        case CHAT_SITUATIONS_FILTER.ASSIGNED:
          filtersDTO.situacao = ChatSituations.ASSIGNED;
          break;
        case CHAT_SITUATIONS_FILTER.WAITING:
          filtersDTO.isOnHold = true;
          break;
        default:
          filtersDTO.situacao = undefined;
          break;
      }

      setFiltersDataDTO(filtersDTO);
      const result = await getMonitoringData(filtersDTO);
      setMonitoringData(result);
    },
    [getMonitoringData]
  );

  const formatDate = (date) => format(date, 'yyyy-MM-dd');

  const parseDate = (dateValue) => {
    if (!dateValue) return null;

    if (typeof dateValue === 'string' && dateValue.includes('/')) {
      const [day, month, year] = dateValue.split('/');
      const teste = new Date(year, month - 1, day);
      return formatDate(teste);
    } else {
      return formatDate(new Date(dateValue));
    }
  };

  const handleFilterConversations = useCallback(
    async ({ orderBy, situation, search } = {}) => {
      setIsLoading(true);

      const loginAtendente = localStorage.getItem('login'); //Login de quem fez a requisição
      const atendente = getValues('atendente');
      const fila = getValues('fila');
      const canal = getValues('idCanal');
      const tags = getValues('tags') || [];
      const state = getValues('state');
      const ddd = getValues('ddd');
      const conta = getValues('conta')?.map((item) => item.value) || [];
      let startDate = getValues('dateBegin');
      let endDate = getValues('dateEnd');

      if (startDate) {
        startDate = parseDate(startDate);
      }

      if (endDate) {
        endDate = parseDate(endDate);
      }
      let formartedState = [];

      if (state) {
        if (typeof state === 'string') {
          formartedState = state.split(',').map((item) => item.trim());
        } else if (Array.isArray(state)) {
          formartedState = state.flatMap((state) => {
            const stateEntry = stateData.find(
              (s) => s.label === state || s.value === state
            );
            return stateEntry
              ? stateEntry.value.split(',').map((item) => item.trim())
              : [];
          });
        }
      }

      handleNewFilters({
        tags: tags?.map((tag) => tag?.value) || [],
        loginAtendente,
        atendente,
        fila,
        nome: search,
        canal,
        telefone: search,
        situacao: situation || situationFilter,
        orderBy: orderBy || orderByFilter,
        messagem: search,
        state: formartedState || [],
        ddd,
        conta,
        startDate: startDate,
        endDate: endDate
      }).then(() => {
        setIsLoading(false);
      });
    },
    [getValues, handleNewFilters, situationFilter, orderByFilter]
  );
  useEffect(() => {
    if (isFirstRender.current === true) {
      isFirstRender.current = false;
      handleFilterConversations();
    }
  }, [handleFilterConversations]);

  useEffect(() => {
    setValue('orderBy', orderByFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderByFilter]);

  useEffect(() => {
    if (socketConversation) {
      socketConversation.onAny((event, payload) => {
        setPossibleEvents({
          event,
          payload
        });
      });
      return () => socketConversation.offAny();
    }
  }, [socketConversation]);

  useEffect(() => {
    if (socketAdm) {
      socketAdm.onAny((event, payload) => {
        setPossibleEvents({
          event,
          payload
        });
      });
      return () => socketAdm.offAny();
    }
  }, [socketAdm]);

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedRows([...selectedRows, row]);
    } else {
      setSelectedRows(selectedRows.filter((x) => x._id !== row._id));
    }
  };

  const handleOnSelectAll = (isSelect, rows) => {
    const allRows = rows.map((r) => {
      return r;
    });
    if (isSelect) {
      setSelectedRows(allRows);
    } else {
      setSelectedRows([]);
    }
  };
  const handleOnSortChange = useCallback(
    async (ordernationParam) => {
      if (ordernationParam === orderByFilter) {
        if (ordernationParam === 'cliente') {
          ordernationParam = 'clienteDesc';
        }
        if (ordernationParam === 'telefone') {
          ordernationParam = 'telefoneDesc';
        }
        if (ordernationParam === 'atendente') {
          ordernationParam = 'atendenteDesc';
        }
        if (ordernationParam === 'atendida') {
          ordernationParam = 'atendidaDesc';
        }
        if (ordernationParam === 'fila') {
          ordernationParam = 'filaDesc';
        }
        if (ordernationParam === 'apelidoCanal') {
          ordernationParam = 'apelidoCanalDesc';
        }
        if (ordernationParam === 'canal') {
          ordernationParam = 'canalDesc';
        }
        if (ordernationParam === 'hora') {
          ordernationParam = 'horaAsc';
        }
        if (ordernationParam === 'situacao') {
          ordernationParam = 'situacaoDesc';
        }
        if (ordernationParam === 'origem') {
          ordernationParam = 'origemDesc';
        }
      }
      setOrderByFilter(ordernationParam);
      handleFilterConversations({
        orderBy: ordernationParam
      });
    },
    [handleFilterConversations, orderByFilter]
  );

  const getReportExelMonitoring = (params = {}) => {
    // recupera configuração da tabela (se houver) de forma segura
    const localStorageState = (() => {
      try {
        return (
          JSON.parse(
            localStorage.getItem(LOCAL_STORAGE_KEYS.CONVERSATION_REPORT_TABLE)
          ) || {}
        );
      } catch {
        return {};
      }
    })();

    // alguns lugares usam 'columnOrder', outros 'columnsOrder' - aceita ambos
    let columnsOrder =
      localStorageState.columnOrder || localStorageState.columnsOrder || null;

    // filtra as colunas removendo aquelas com columnVisibility: false
    const columnVisibility = localStorageState.columnVisibility || {};
    if (columnsOrder && Array.isArray(columnsOrder)) {
      columnsOrder = columnsOrder.filter(
        (columnId) => columnVisibility[columnId] !== false
      );
    }

    const queryParams = {
      ...params,
      columnsOrder
    };
    console.log('queryParams', queryParams);
    setIsLoading(true);
    exelReport
      .getReportExelMonitoring({
        queryParams
      })
      .then((res) => {
        if (res.data.size === 0) toast.info('Nenhum registro foi encontrado!');
        else {
          saveAs(
            new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'
            }),
            `relatorio-monitoramento-${new Date()}.xlsx`
          );
        }
      })
      .catch((err) => {
        console.error('Erro ao gerar relatório de monitoramento', err);
        toast.error('Erro ao gerar relatório.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleFilterDDD = (data) => {
    const categories = [];
    const result = data.map((action) => {
      let category;
      let isDivisor = false;
      let label = action.label;

      if (!categories.includes(action.regiao)) {
        categories.push(action.regiao);
        isDivisor = true;
      }

      switch (action.regiao) {
        case 'Centro-Oeste':
          category = 'Centro-Oeste';
          break;
        case 'Nordeste':
          category = 'Nordeste';
          break;
        case 'Norte':
          category = 'Norte';
          break;
        case 'Sudeste':
          category = 'Sudeste';
          break;
        case 'Sul':
          category = 'Sul';
          break;
        default:
      }

      return {
        label: `${label} ${action.stateId ? ` - ${action.stateId}` : ''}`,
        value: action.value,
        divisorCategory: isDivisor ? category : undefined
      };
    });

    return result;
  };

  useEffect(() => {
    setValue('situacao', situationFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [situationFilter]);

  let attendantQueues = localStorage.getItem('queues');
  if (attendantQueues) {
    attendantQueues = JSON.parse(attendantQueues);
  }

  const data = useMemo(
    () => ({
      monitoringData,
      possibleEvents,
      attendantQueues
    }),
    [monitoringData, possibleEvents, attendantQueues, handleNewFilters]
  );

  useEffect(() => {
    try {
      const events = [
        'conversa_atendida',
        'entrou_na_fila',
        'conversa_iniciada',
        'conversa_encerrada',
        'conversa_transferida_para_atendente',
        'contact_update_name',
        'update_conversation',
        'add_chat_in_monitoring',
        'remove_chat_from_monitoring',
        'update_chat_in_monitoring'
      ];

      if (!events.includes(possibleEvents.event)) {
        return;
      } else {
        let orderBy = getValues('orderBy');

        data.orderBy = orderBy;

        data.currentFilters = filtersDataDTO;

        sendMessageWork({
          type: 'monitoring',
          data
        });

        addMessageListener((e) => {
          if (e.type === 'monitoring') {
            setMonitoringData(e.data);
            possibleEvents.event = null;
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getValues,
    possibleEvents,
    setMonitoringData,
    filtersDataDTO,
    orderByFilter
  ]);

  useEffect(() => {
    ConversationReportService.getConfigProtocolChat()
      .then((response) => {
        const { criarProtocoloParaConversaNoMonitoramento } = response.data;
        setShouldCreateProtocolOnConversationEnd(
          criarProtocoloParaConversaNoMonitoramento
        );
      })
      .catch((error) => {
        if (error.response) {
          toast.error('Erro ao carregar configurações!', {
            autoClose: 3000,
            closeOnClick: true
          });
        }
        return false;
      });
  }, [tagsIdName]);

  const selectedAgentRows = React.useMemo(() => {
    const selectedIds = Object.entries(selectedRows ?? {})
      .filter(([, isSelected]) => Boolean(isSelected))
      .map(([id]) => id);

    if (!selectedIds.length) return [];

    const selectedIdsSet = new Set(selectedIds);

    return (monitoringData?.data?.conversas ?? []).filter((conversation) => {
      const conversationId = conversation?._id ?? conversation?.id;
      return conversationId && selectedIdsSet.has(String(conversationId));
    });
  }, [selectedRows, monitoringData]);
  return (
    <>
      <RowMonitoring
        style={{
          margin: 0,
          position: 'relative',
          top: '0',
          display: 'flex',
          justifyContent: 'end',
          width: 'auto'
        }}
      >
        <ColMonitoring style={{ padding: '0', margin: '0' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'nowrap',
              position: 'relative',
              padding: '0',
              marginRight: '0.5rem'
            }}
          >
            <SearchChatsInput
              placeholder="Buscar conversas..."
              onChange={(e) => {
                if (idTimeoutSearch) clearTimeout(idTimeoutSearch);
                const value = e.target.value;
                function setCurrentValue() {
                  handleFilterConversations({ search: value });
                }
                idTimeoutSearch = setTimeout(setCurrentValue, 2000);
              }}
            />

            <SearchButton
              bgColor={systemConfiguration.primary_color}
              right=".28rem"
            >
              <IoSearch size={20} color="#fff" />
            </SearchButton>
          </div>

          <TransferManyButton
            id={selectedAgentRows}
            setSelectedRows={setSelectedRows}
            altIcon={true}
          />
          <CloseManyButton
            selectedConversations={selectedAgentRows}
            skipProtocolCreation={false}
            altIcon={true}
            shouldCreateProtocolOnConversationEnd={
              shouldCreateProtocolOnConversationEnd
            }
            onSuccess={() => setSelectedRows([])}
          />
          <CardAttendants
            title="Atendentes Logados"
            loggedAttendants={loggedAttendants}
            altIcon={true}
          />
        </ColMonitoring>
      </RowMonitoring>
      <Row className="mb-3">
        <Col md="8" className="me-4">
          <DateRangeFilter
            control={control}
            setValue={setValue}
            onChange={handleFilterConversations}
            errors={errors}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </Col>
      </Row>
      <Row>
        <Form
          className="needs-validation"
          style={{
            width: '100%'
          }}
          onSubmit={handleSubmit(handleFilterConversations)}
        >
          <input type="hidden" name="situacao" ref={register} />
          <input type="hidden" name="orderBy" ref={register} />
          <Row
            className="mb-3"
            style={{
              padding: '0.5rem 1rem 0 1rem'
            }}
          >
            <Col md="2">
              <label className="form-control-label">Atendente</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    dataOptions={users}
                    closeMenuOnSelect={false}
                    isMulti={true}
                    isClearable={true}
                    value={props.value}
                    valueController={(fieldName, value) => {
                      setValue(fieldName, value);
                    }}
                    fieldName="atendente"
                    labelName="name"
                    valueName="login"
                  />
                )}
                control={control}
                name="atendente"
                defaultValue=""
              />
            </Col>

            <Col md="2">
              <label className="form-control-label">Fila</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    dataOptions={queues}
                    isMulti={true}
                    closeMenuOnSelect={false}
                    isClearable={true}
                    value={props.value}
                    valueController={(fieldName, value) => {
                      setValue(fieldName, value);
                    }}
                    fieldName="fila"
                    labelName="name"
                    valueName="name"
                  />
                )}
                control={control}
                name="fila"
                defaultValue=""
              />
            </Col>

            <Col md="2">
              <Controller
                render={(props) => (
                  <FlexSelectSearchTag
                    name="tags"
                    setValueSelected={(data) => {
                      setValue('tags', data);
                    }}
                    setAllTags={(data) => {
                      const tagsById = {};
                      data?.length > 0 &&
                        data.forEach((tag) => {
                          tagsById[tag.id] = tag;
                        });
                      setTagsIdName(tagsById);
                    }}
                    value={props.value}
                  />
                )}
                control={control}
                name="tags"
                defaultValue=""
              />
            </Col>

            <Col md="2">
              <label className="form-control-label">DDD do Contato</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    dataOptions={handleFilterDDD(dddsData)}
                    isMulti={true}
                    isClearable={true}
                    value={props.value}
                    valueController={setValue}
                    closeMenuOnSelect={true}
                    fieldName="ddd"
                    labelName="label"
                    valueName="value"
                    placeholder="Selecione..."
                    onChange={(selected) =>
                      setValue('ddd', selected?.value || '')
                    }
                  />
                )}
                control={control}
                name="ddd"
                defaultValue=""
              />
            </Col>
            <Col md="2">
              <label className="form-control-label">Estado</label>
              <Controller
                render={(props) => {
                  return (
                    <FlexSelect
                      dataOptions={handleFilterDDD(stateData)}
                      isMulti={true}
                      isClearable={true}
                      value={props.value}
                      valueController={setValue}
                      closeMenuOnSelect={true}
                      fieldName="state"
                      labelName="label"
                      valueName="value"
                      placeholder="Selecione..."
                      onChange={(selected) => {
                        const newValue = selected
                          ? selected.map((item) => item.value)
                          : [];
                        setValue('state', newValue);
                      }}
                    />
                  );
                }}
                control={control}
                name="state"
                defaultValue=""
              />
            </Col>
            <Col md="2">
              <label className="form-control-label">Nome do Canal</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    dataOptions={canalOptions}
                    isMulti={true}
                    isClearable={true}
                    value={props.value}
                    valueController={setValue}
                    closeMenuOnSelect={false}
                    fieldName="idCanal"
                    labelName="label"
                    valueName="label"
                  />
                )}
                control={control}
                name="idCanal"
                defaultValue=""
              />
            </Col>
          </Row>
          <Row
            className="mb-3"
            style={{
              padding: '0rem 1rem 0 1rem'
            }}
          >
            <Col md="2">
              <FlexController
                textoDoLabel="Conta"
                type="selectable"
                name="conta"
                options={accountsOptions}
                valueController={setValue}
                isMulti
                closeMenuOnSelect
                isClearable
                isSearchable
                portalTarget={false}
                errors={{}}
                control={control}
              />
            </Col>
          </Row>

          <Row
            style={{
              padding: '0.5rem 1rem 0 1rem'
            }}
          >
            <div className="ml-3">
              <UserFlexSelect
                usersShowDisable={usersShowDisable}
                setUsersShowDisable={setUsersShowDisable}
                name={'Atendentes'}
              />
            </div>
          </Row>

          <Row style={{ marginLeft: 0, marginTop: '1rem' }}>
            <ColMonitoring style={{ gap: '0.5rem' }}>
              {buttonsFilterMonitoring.map((button) => {
                return (
                  <ButtonFilter
                    key={button.label}
                    color={button.color}
                    type="button"
                    title={button.title}
                    label={button.label}
                    onClick={() =>
                      handleChangeSituationFilter(button.typeOfFilter)
                    }
                    isActive={situationFilter === button.typeOfFilter}
                  >
                    <i className={button.icon}></i>
                  </ButtonFilter>
                );
              })}
            </ColMonitoring>
          </Row>

          <Row
            className="mb-12"
            style={{
              padding: '0.5rem 1rem 0 1rem',
              marginBottom: '1rem'
            }}
          >
            <Col
              md="6"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                marginTop: '1rem'
              }}
            >
              <Button
                style={buttonStyle(systemConfiguration.primary_color)}
                type="submit"
                title="Filtrar Conversas"
                disabled={isLoadingMonitoringData}
              >
                Filtrar
              </Button>
            </Col>

            <Col
              md="6"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                marginTop: '1rem'
              }}
            >
              <button
                id="button_xlsx"
                style={ImageButton}
                onClick={() => getReportExelMonitoring(filtersDataDTO)}
                disabled={
                  monitoringData?.data?.conversas?.length ? false : true
                }
              >
                {isLoading ? (
                  <Loader
                    type="TailSpin"
                    color="#35ac50"
                    height={42}
                    width={42}
                  />
                ) : (
                  <Tooltip
                    title={
                      <p style={{ fontSize: '14px' }}>
                        {monitoringData?.data?.conversas?.length
                          ? 'Clique para realizar o download'
                          : 'Nenhum registro para realizar download'}
                      </p>
                    }
                    arrow
                  >
                    <img src={xlsxImage} alt="xlsx" style={ImageSize} />
                  </Tooltip>
                )}
              </button>
            </Col>
          </Row>
          <Row style={{ padding: '0.5rem 1rem 0 1rem' }}>
            <Col
              md="12"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '1rem'
              }}
            >
              <div
                className="small"
                style={{
                  height: '2rem'
                }}
              >
                <span>
                  {!selectedAgentRows || selectedAgentRows?.length === 0
                    ? ''
                    : selectedAgentRows?.length === 1
                    ? `${selectedAgentRows.length} conversa selecionada.`
                    : `${selectedAgentRows.length} conversas selecionadas.`}
                </span>
              </div>
            </Col>
          </Row>
        </Form>
      </Row>

      <Card
        style={{
          borderRadius: systemConfiguration.border_radius,
          boxShadow: 'none'
        }}
      >
        {isLoadingMonitoringData ? (
          <Row
            className="mb-12"
            style={{
              display: 'block',
              overflowX: 'auto',
              width: '100%',
              height: '100%',
              margin: '1rem 0 0 0'
            }}
          >
            <TableLoader />
          </Row>
        ) : (
          <TableMonitoring
            data={monitoringData?.data?.conversas || []}
            isCurrentAgentsLogged={loggedAttendants}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            handleOnSelect={handleOnSelect}
            handleOnSelectAll={handleOnSelectAll}
            sorting={sorting}
            setSorting={setSorting}
            idNameTags={tagsIdName}
          />
        )}
      </Card>
    </>
  );
};
